import Vue from 'vue'
export const ChatMessageBus = new Vue()
